export default (() => {
    const CATEGORY_PARKING_ID = 1;
    const CATEGORY_TAXI_ID = 2;
    const CATEGORY_TRANSFER_ID = 3;
    const CATEGORY_HUB_ID = 4;
    const CATEGORY_BIKE_ID = 5;

    const CATEGORY_PARKING_TYPE = 'parking';
    const CATEGORY_TAXI_TYPE = 'taxi';
    const CATEGORY_TRANSFER_TYPE = 'transfer';
    const CATEGORY_HUB_TYPE = 'hubs';
    const CATEGORY_BIKE_TYPE = 'bikes';

    return {
        getCategoryBikeId: function () {
            return CATEGORY_BIKE_ID;
        },

        getCategoryHubId: function () {
            return CATEGORY_HUB_ID;
        },

        getCategoryParkingId: function () {
            return CATEGORY_PARKING_ID;
        },

        getCategoryTaxiId: function () {
            return CATEGORY_TAXI_ID;
        },

        getCategoryTransferId: function () {
            return CATEGORY_TRANSFER_ID;
        },

        isBike: function (categoryId) {
            return categoryId === CATEGORY_BIKE_ID;
        },

        isHub: function (categoryId) {
            return categoryId === CATEGORY_HUB_ID;
        },

        isParking: function (categoryId) {
            return categoryId === CATEGORY_PARKING_ID;
        },

        isTaxi: function (categoryId) {
            return categoryId === CATEGORY_TAXI_ID;
        },

        isTransfer: function (categoryId) {
            return categoryId === CATEGORY_TRANSFER_ID;
        },

        getCategoryType: function (categoryId) {
            let result;

            switch (categoryId) {
                case CATEGORY_HUB_ID:
                    result = CATEGORY_HUB_TYPE;
                    break;
                case CATEGORY_BIKE_ID:
                    result = CATEGORY_BIKE_TYPE;
                    break;
                case CATEGORY_PARKING_ID:
                    result = CATEGORY_PARKING_TYPE;
                    break;
                case CATEGORY_TAXI_ID:
                    result = CATEGORY_TAXI_TYPE;
                    break;
                case CATEGORY_TRANSFER_ID:
                    result = CATEGORY_TRANSFER_TYPE;
                    break;
                default:
                    break;
            }

            return result;
        },
    };
})();



// WEBPACK FOOTER //
// ./src/helpers/category.js